export const GET_PUERTOS='GET_PUERTOS';
export const GET_NAVE_BY_OMI='GET_NAVE_BY_OMI';
export const GET_TIPONAVE='GET_TIPONAVE';

export const GET_PERSONA='GET_PERSONA';
export const GET_NACIONALIDADES='GET_NACIONALIDADES';
export const GET_SEXOS='GET_SEXOS';

export const GET_PUESTOS_TRABAJO='GET_PUESTOS_TRABAJO';
export const GET_PARAMETROS='GET_PARAMETROS';
export const GET_MATERIAS_QUEJAS='GET_MATERIAS_QUEJAS';

export const GET_EMPRESA='GET_EMPRESA';

export const POST_QUEJA='POST_QUEJA';



